import React from 'react'
import Colors from '../assets/Colors'
import classes from './PageProgressBar.module.css'

function PageProgressBar({ progress }) {
    return (
        <div className={classes.progressContainer} style={{ background: Colors.mainShadeOfSolitude }}>
            <div className={classes.progressValue} style={{ background: Colors.mainBlue, width: progress  }} />
        </div>
    )
}

export default PageProgressBar